import { browserHistory } from 'react-router';
import { isActive } from './service';

export default (state = isActive(browserHistory)) => state;
